import { classNames, parseObjectPositionResponsive, ResponsiveStringValue } from "@punks/ui-core"
import { responsiveCssVariables } from "../utils/variables"


export const usePositioningProps = ({
    objectPosition,
    position,
    size
}: {
    objectPosition?: ResponsiveStringValue
    position?: ResponsiveStringValue
    size?: ResponsiveStringValue
}) => {
    const parsedPosition = position ?
        parseObjectPositionResponsive(position) :
        undefined

    return {
        classes: classNames({
            // size
            "w-[var(--size)]": !!size?.xs,
            "sm:w-[var(--size-sm)]": !!size?.sm,
            "md:w-[var(--size-md)]": !!size?.md,
            "lg:w-[var(--size-lg)]": !!size?.lg,
            "xl:w-[var(--size-xl)]": !!size?.xl,
            "min-h-[var(--size)]": !!size?.xs,
            "sm:min-h-[var(--size-sm)]": !!size?.sm,
            "md:min-h-[var(--size-md)]": !!size?.md,
            "lg:min-h-[var(--size-lg)]": !!size?.lg,
            "xl:min-h-[var(--size-xl)]": !!size?.xl,
            // object position
            "object-[var(--obj-position)]": !!objectPosition?.xs,
            "sm:object-[var(--obj-position-sm)]": !!objectPosition?.sm,
            "md:object-[var(--obj-position-md)]": !!objectPosition?.md,
            "lg:object-[var(--obj-position-lg)]": !!objectPosition?.lg,
            "xl:object-[var(--obj-position-xl)]": !!objectPosition?.xl,
            // top
            "top-[var(--top)]": !!parsedPosition?.xs?.top,
            "sm:top-[var(--top-sm)]": !!parsedPosition?.sm?.top,
            "md:top-[var(--top-md)]": !!parsedPosition?.md?.top,
            "lg:top-[var(--top-lg)]": !!parsedPosition?.lg?.top,
            "xl:top-[var(--top-xl)]": !!parsedPosition?.xl?.top,
            // bottom
            "bottom-[var(--bottom)]": !!parsedPosition?.xs?.bottom,
            "sm:bottom-[var(--bottom-sm)]": !!parsedPosition?.sm?.bottom,
            "md:bottom-[var(--bottom-md)]": !!parsedPosition?.md?.bottom,
            "lg:bottom-[var(--bottom-lg)]": !!parsedPosition?.lg?.bottom,
            "xl:bottom-[var(--bottom-xl)]": !!parsedPosition?.xl?.bottom,
            // left
            "left-[var(--left)]": !!parsedPosition?.xs?.left,
            "sm:left-[var(--left-sm)]": !!parsedPosition?.sm?.left,
            "md:left-[var(--left-md)]": !!parsedPosition?.md?.left,
            "lg:left-[var(--left-lg)]": !!parsedPosition?.lg?.left,
            "xl:left-[var(--left-xl)]": !!parsedPosition?.xl?.left,
            // right
            "right-[var(--right)]": !!parsedPosition?.xs?.right,
            "sm:right-[var(--right-sm)]": !!parsedPosition?.sm?.right,
            "md:right-[var(--right-md)]": !!parsedPosition?.md?.right,
            "lg:right-[var(--right-lg)]": !!parsedPosition?.lg?.right,
            "xl:right-[var(--right-xl)]": !!parsedPosition?.xl?.right,
        }),
        styles: {
            ...(parsedPosition && {
                ...responsiveCssVariables("top", {
                    xs: parsedPosition.xs?.top,
                    sm: parsedPosition.sm?.top,
                    md: parsedPosition.md?.top,
                    lg: parsedPosition.lg?.top,
                    xl: parsedPosition.xl?.top,
                }),
                ...responsiveCssVariables("bottom", {
                    xs: parsedPosition.xs?.bottom,
                    sm: parsedPosition.sm?.bottom,
                    md: parsedPosition.md?.bottom,
                    lg: parsedPosition.lg?.bottom,
                    xl: parsedPosition.xl?.bottom,
                }),
                ...responsiveCssVariables("left", {
                    xs: parsedPosition.xs?.left,
                    sm: parsedPosition.sm?.left,
                    md: parsedPosition.md?.left,
                    lg: parsedPosition.lg?.left,
                    xl: parsedPosition.xl?.left,
                }),
                ...responsiveCssVariables("right", {
                    xs: parsedPosition.xs?.right,
                    sm: parsedPosition.sm?.right,
                    md: parsedPosition.md?.right,
                    lg: parsedPosition.lg?.right,
                    xl: parsedPosition.xl?.right,
                }),
            }),
            ...(objectPosition && responsiveCssVariables("obj-position", objectPosition)),
            ...(size && responsiveCssVariables("size", size)),
        },
    }
}
